import { site } from '@wix/site';
import { createClient } from '@wix/sdk';

import type { AuthenticationStrategy, Host } from '@wix/sdk';

export const enableClient = (applicationId: string) => {
  const host = site.host({ applicationId });
  const auth = site.auth();
  const injectGetAccessToken = auth.getAccessTokenInjector();

  const wixClient = createClient({
    auth,
    host,
  });
  wixClient.enableContext('module');

  return {
    injectGetAccessToken,
  };
};

export const enablePanelClient = ({
  host,
  auth,
}: {
  host: Host;
  auth?: AuthenticationStrategy;
}) => {
  const wixClient = createClient({ host, auth });
  wixClient.enableContext('module');
};
